import { Store } from "redux"

/**
 * @legacy Module-level store reference for utility functions
 * (showFoneAlert, closeFoneAlert, clearStorageData, logoutFromIframes)
 * that access coreStore outside the thunk/middleware context.
 *
 * Remove once all apps are migrated — these utility functions should
 * be refactored to accept dispatch/getState as parameters or moved
 * into thunks, eliminating the need for this indirect store reference.
 */
let _store: Store | null = null

export function setStoreRef(store: Store): void {
  _store = store
}

export function getStoreRef(): Store {
  return _store!
}
